import icon from '../images/unavalibleMobileImage.png';
import { Colors } from '../themes/colors';
import { Button } from '@tempmee/react';
import { getMobileStoreUrl } from '../utils/mobileStore';

export const UnavailableMobile = () => {
  // Same-tab navigation rather than window.open: in-app webviews (Gmail,
  // LinkedIn) block popups, which made the button do nothing at all.
  const submitButtonPressed = () => {
    window.location.assign(getMobileStoreUrl());
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img
        src={icon}
        alt="Unavailable Mobile"
        style={{ marginTop: 50, marginBottom: 30, maxWidth: 300 }}
      />
      <span
        style={{
          fontFamily: 'Nunito',
          fontWeight: 'bold',
          fontSize: 18,
          textAlign: 'center',
          width: '80%',
          marginBottom: 40,
          color: Colors.neutral_600,
          display: 'block',
        }}
      >
        To continue with GoTu’s Dental Portal, come back on desktop or download the app.
      </span>
      <Button size="lg" onClick={submitButtonPressed}>
        Download GoTu
      </Button>
    </div>
  );
};
